import {
    ChangeEvent,
    FocusEvent,
    Ref,
    CSSProperties,
    KeyboardEventHandler,
} from 'react';
import { StyledInputMask as BaseInputMask } from '@motili/ui';
import classNames from 'classnames';
import styles from './StyledInputMask.module.scss';

interface StyledInputMaskProps {
    saveUnmasked?: boolean;
    mask?: string;
    replacement?: Record<string, RegExp>;
    showMask?: boolean;
    defaultValue?: string;
    value?: string;
    disabled?: boolean;
    placeholder?: string;
    autoFocus?: boolean;
    className?: string;
    name?: string;
    type?: string;
    style?: CSSProperties;
    'data-test-id'?: string;
    ref?: Ref<HTMLInputElement>;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
    onFocus?: () => void;
    onKeyPress?: KeyboardEventHandler<HTMLInputElement>;
}

export const StyledInputMask = ({
    saveUnmasked,
    onChange,
    onBlur,
    mask,
    replacement,
    showMask,
    defaultValue,
    value,
    disabled,
    placeholder,
    autoFocus,
    className,
    name,
    type,
    style,
    'data-test-id': dataTestId,
    ref,
    onFocus,
    onKeyPress,
}: StyledInputMaskProps) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (!onChange) return;
        const isEmpty = e.target.value === mask;
        const normalized = isEmpty
            ? { ...e, target: { ...e.target, value: '' } }
            : e;
        if (saveUnmasked) {
            onChange({
                ...normalized,
                target: {
                    ...normalized.target,
                    value: normalized.target.value.replace(/\D/g, ''),
                },
            });
        } else {
            onChange(normalized);
        }
    };

    const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
        if (!onBlur) return;
        const isEmpty = e.target.value === mask;
        onBlur(
            isEmpty
                ? ({
                      ...e,
                      target: { ...e.target, value: '' },
                  } as FocusEvent<HTMLInputElement>)
                : e
        );
    };

    const combinedClassName = classNames(styles.styledInputMask, className);

    return (
        <BaseInputMask
            ref={ref}
            mask={mask}
            replacement={replacement}
            showMask={showMask}
            defaultValue={defaultValue}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            autoFocus={autoFocus}
            className={combinedClassName}
            name={name}
            type={type}
            style={style}
            data-test-id={dataTestId}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={onFocus}
            onKeyPress={onKeyPress}
        />
    );
};
